import { store } from '@/store/store'

export default {
  
  getTokensCheck() { 
    var isNotMultiConnect = Boolean(store.state.params.isNotMultiConnect);

    if (isNotMultiConnect) {

      var model = store.state.model;
  
      // On récupère les valeurs issues du localStorage
      var localToken = '';
      var localTokenFM = '';
      var localTokenID = '';
      var tokenName = model.getTokenName(); // "fm-data-api"
      var localTokenJs = localStorage.getItem(tokenName) || undefined;
      if (localTokenJs) {
        localToken = JSON.parse(localTokenJs);
        localTokenFM = localToken.token;
        localTokenID = localToken.tokenID;
      }
      
      // On récupère les valeurs issues du $store
      var savedToken = '';
      var savedTokenFM = '';
      var savedTokenID = '';
      var savedTokenJs = store.state.tokens;
      if (savedTokenJs) {
        savedToken = JSON.parse(savedTokenJs);
        savedTokenFM = savedToken.tokenFM;
        savedTokenID = savedToken.tokenID;
      }
  
      // On vérifie qu'il n'y a qu'une seule connexion
      var isTokenFM = Boolean(savedTokenFM && localTokenFM && (localTokenFM === savedTokenFM));
      var isTokenID = Boolean(savedTokenID && localTokenID && (localTokenID === savedTokenID));
      // console.log('🛑🛑🛑-tokensCheck-isToken',[isTokenFM,isTokenID]);
  
      return Boolean(isTokenFM && isTokenID);

    } else {
      return true;
    }
  
  },
}



// WEBPACK FOOTER //
// ./src/router/tokensCheck.js